/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { useEffect, useState } from 'react';

import { IAccountPreference, IAccountPreferences, IAccountProfileItem, IAccountProfileViewProps } from './account-profile';

const AccountPreferencesSection: React.FC<IAccountPreferences> = ({ accountPreferences, heading, personalization, extraPreferences }) => {
    return (
        <Node {...accountPreferences}>
            {heading}
            <AccountPreferenceSection {...personalization} />
            {extraPreferences &&
                extraPreferences.map((preferenceSecton, index) => {
                    return <AccountPreferenceSection {...preferenceSecton} key={index} />;
                })}
        </Node>
    );
};

const AccountPreferenceSection: React.FC<IAccountPreference> = ({
    accountPreference,
    heading,
    description,
    buttonWrapper,
    buttonYesText,
    button,
    buttonNoText
}) => {
    return (
        <Node {...accountPreference}>
            {heading}
            {description}
            <Node {...buttonWrapper}>
                {buttonNoText}
                {button}
                {buttonYesText}
            </Node>
        </Node>
    );
};

const AccountProfileSection: React.FC<IAccountProfileItem> = ({ AccountProfileItem, heading, links, description }) => {
    return (
        <Node {...AccountProfileItem}>
            {heading}
            {description}
            {links}
        </Node>
    );
};

const AccountProfileView: React.FC<IAccountProfileViewProps> = props => {
    const {
        AccountProfile,
        accountProfileWrapper,
        heading,
        customerAccountSection,
        emailSection,
        nameSection,
        preferenceSection,
        customerAttributesWrapper,
        customerAttributesSection
    } = props;
    return (
        <Module {...AccountProfile}>
            {accountProfileWrapper && (
                <Node {...accountProfileWrapper}>
                    {heading}
                    <RenderCustomerId {...customerAccountSection} />
                    <AccountProfileSection {...emailSection} />
                    <AccountProfileSection {...nameSection} />
                    <AccountPreferencesSection {...preferenceSection} />
                </Node>
            )}
            {customerAttributesWrapper && <Node {...customerAttributesWrapper}>{customerAttributesSection}</Node>}
        </Module>
    );
};

const RenderCustomerId: React.FC<IAccountProfileItem> = props => {
    const customerId: any = null;
    let tokenNum = '';

    const [custId, setCustomerId] = useState(customerId);

    useEffect(() => {
        const w: any = window;
        if (!w) {
            return;
        }

        const initialData = w.___initialData___;
        tokenNum = initialData.requestContext.user.token;

        var base64Url = tokenNum.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map(function(c) {
                    let charCode = c.charCodeAt(0).toString(16);
                    charCode = `00${charCode}`;
                    charCode = charCode.slice(-2);
                    charCode = `%${charCode}`;
                    return charCode;
                })
                .join('')
        );

        var sfdc_token = JSON.parse(jsonPayload).idp_access_token;
        var urlTarget = `https://cirfullsb-cirrusaircraftvpo.cs9.force.com/cirrusaccount/services/oauth2/userinfo?access_token=${sfdc_token}`;

        fetch(urlTarget, {
            mode: 'cors'
        })
            .then(response => response.json())
            .then(data => setCustomerId(data.custom_attributes.CirrusBucksAccountNumber));
    }, []);
    return (
        <div>
            {custId !== null && (
                <div className='ms-account-profile__section ms-account-profile__section-customer-id'>
                    <h2 className='ms-account-profile__section-heading'>Customer ID</h2>
                    <p className='ms-account-profile__section-description'>{custId}</p>
                </div>
            )}
        </div>
    );
};

export default AccountProfileView;
